
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.sticky-header');
  const banner = document.querySelector('.shopify-section-template--16779133288550__image_banner'); 

  // Make sure the banner element exists
  if (!header || !banner) return; 

  const bannerHeight = banner.offsetHeight; 

  window.addEventListener('scroll', function () {
    
    let scrollY = window.scrollY;
    
    
    if (scrollY > bannerHeight) {
      // Gradually increase opacity as you scroll down
      let opacity = Math.min(1, (scrollY - bannerHeight) / 200); // Adjust '200' to control speed of fading
      header.style.backgroundColor = `rgba(255, 255, 255, ${opacity})`;
    } else {
      // Keep it fully transparent as long as it's over the banner
      header.style.backgroundColor = 'rgba(255, 255, 255, 0)';
    }
  });
});
